import { RoleEnum } from "~/types/User";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const userStore = useUserStore();
    const navTabs = useNavTabs()
    const tokenCookie = useCookie('access_token');

    // КРИТИЧЕСКАЯ ПРОВЕРКА: если мы на главной странице, но должны быть на create-account
    // Блокируем рендеринг главной страницы ДО того, как она начнет рендериться
    if ((to.name === 'home' || to.path === '/' || to.path === '')) {
        const isLoggedIn = userStore.isAuthenticated || !!tokenCookie.value;
        const hasMissingFields = !userStore.user?.username || !userStore.user?.user_role;
        
        if (isLoggedIn && hasMissingFields && !userStore.loading) {
            // Редиректим на create-account ДО рендеринга главной страницы
            // Layout будет установлен через definePageMeta на странице create-account
            return navigateTo({ name: 'create_account' }, { external: true, replace: true });
        }
    }

    // Если пользователь авторизован, но данные не загружены и не в процессе загрузки
    if (userStore.access_token && !userStore.user && !userStore.loading) {
        try {
            await userStore.restoreState();
            // Если после восстановления состояния пользователь все еще null, значит произошла ошибка
            if (!userStore.user) {
                console.log('middleware:User not found')
                //await userStore.logout();
                return navigateTo('/', { external: true, replace: true });
            }
        } catch (error) {
            console.error('Error restoring user state:', error);
            await userStore.logout();
            return navigateTo('/', { external: true, replace: true });
        }
    }
    
    const isLoggedIn = userStore.isAuthenticated;
    const profileRoute = navTabs.value.find(item => item.path === to.path && item.isPrivate) || null;
    
    // Проверяем все условия для редиректа на главную
    const shouldRedirectToHome = 
        (!isLoggedIn && !tokenCookie.value && to.path.includes('create-account')) ||
        (!isLoggedIn && !tokenCookie.value && to.path.includes('office')) ||
        (!isLoggedIn && !tokenCookie.value && to.path.includes('order-create')) ||
        (!isLoggedIn && !tokenCookie.value && to.name === 'help_ticket') ||
        (isLoggedIn && userStore.user?.username && userStore.user?.user_role && to.path.includes('create-account')) ||
        (isLoggedIn && userStore.user?.user_role === 'MASTER' && to.path.includes('order-create')) ||
        (isLoggedIn && profileRoute && !profileRoute.role.includes(userStore.currentRole as RoleEnum));

    if (shouldRedirectToHome) {
        return navigateTo('/', { external: true, replace: true });
    }

    // Проверяем необходимость редиректа на create-account
    // Важно: проверяем это ПОСЛЕ проверки shouldRedirectToHome, чтобы избежать конфликтов
    const shouldRedirectToCreateAccount = 
        !userStore.loading && 
        (isLoggedIn || !!tokenCookie.value) && 
        (!userStore.user?.username || !userStore.user?.user_role) && 
        !to.path.includes('create-account') && 
        !to.path.includes('terms-of-service') && 
        !to.path.includes('privacy-policy') &&
        to.name !== 'create_account';

    if (shouldRedirectToCreateAccount) {
        // Редиректим на create-account
        // Layout будет установлен через definePageMeta на странице create-account
        return navigateTo({ name: 'create_account' }, { external: true, replace: true });
    }

    // Дополнительная проверка: если мы на create-account, но пользователь не должен быть там
    if (to.path.includes('create-account') || to.name === 'create_account') {
        const isLoggedIn = userStore.isAuthenticated || !!tokenCookie.value;
        const hasAllFields = userStore.user?.username && userStore.user?.user_role;
        
        // Если пользователь не залогинен или уже заполнил все поля, редиректим на главную
        if (!isLoggedIn || hasAllFields) {
            // Редиректим на главную - layout будет установлен через definePageMeta на главной странице
            return navigateTo('/', { external: true, replace: true });
        }
    }

});